import React from 'react';

function NoPage() {
    return (
        <h1 style={{textAlign: "center"}}>There is no page.</h1>
    );
}

export default NoPage;